<p
    #elm
    class="price"
    [ngClass]="{
        'is-main-price': isMainPrice,
        'has-description': hasIcon,
        'has-text-grey-dark': isDiscountPrice,
        'is-greyed': isDiscountPrice,
        'is-striked': isDiscountPrice
    }"
>
    <span [ngClass]="{ main: !isInlined }">
        @if (isAdditionalPrice) {
            <span>+</span>
        }
        <span>{{ mainPrice }}{{ centimePrice && isInlined ? ',' : '' }}</span>
    </span>
    <span [ngClass]="{ 'price-details': !isInlined }">
        <span [ngClass]="{ cents: !isInlined }">
            @if (!isInlined) {
                €{{ centimePrice }}
            } @else {
                <span>{{ centimePrice }} €</span>
            }
            @if (isWithoutTax && isInlined) {
                <span>{{ ' ' }}HT</span>
            }
            @if ((isWithoutTax && !isInlined) || asterix) {
                <sup>{{ isWithoutTax && !isInlined ? 'HT' : '' }} {{ asterix ? '(' + asterix + ')' : '' }}</sup>
            }
            @if (hasIcon) {
                <span class="icon">
                    <span [ngClass]="iconClassNames" (click)="clickIcon()"></span>
                </span>
            }
        </span>
        @if (hasPeriod) {
            <span class="period">/mois</span>
        }
    </span>
</p>
